module.exports = __webpack_public_path__ + "img/uf23.b93a28d7.png";